import React, { useState,useEffect } from "react";
import "../Myprojects.css"
import {columnsDataComplex} from "../../tables/variables/columnsData";
import ModelsTable from "../../tables/components/ModelsTable";
import { TbFile3D } from "react-icons/tb";
import { FILES_URL } from '../../../../configs/AppConfig';



const Model3d = ({data}) => {
      const [tableData , setTableData] = useState([]); 
      const [selected, setSelected] = useState(null);
      // const [imgs, setImgs] = useState([]);

      useEffect(() => {
              setTableData(data.model3d?.modelParts)
              // setImgs(data.model3d?.imgs)
        }, [data]);

    const selectPlate =(id)=>{
      setSelected(id);
        console.log("Selected Plate ID:", id);
      }
  return (
    <div>
      {/* <Header /> */}
      <div className="model3d-container"> 
        <div className="model3d-cards" >
           {tableData.map(img =>
                      <div className={selected === img.id ? "model3d-cardSelected" : "model3d-card"} style={{backgroundImage:`url(${FILES_URL}${img.img?.url})`}}>
                      </div>
                   )}
        </div>
  <div className="table3D">
        <ModelsTable
          columnsData={columnsDataComplex}
          tableData={tableData}
          selectPlate ={selectPlate}
        />
     <div className="print3D"><TbFile3D className="printIcon"/><span>Print</span></div>
   </div>
   
        </div>
    </div>
  );
};

export default Model3d;
